<template>
<div>
  <el-table
    :data="noticeList"
  >
    <el-table-column
      prop="id"
      label="ID">
    </el-table-column>
    <el-table-column
      label="标题(中文)">
      <template slot-scope="{ row }">
        {{ JSON.parse(row.title)['1'] }}
      </template>
    </el-table-column>
    <el-table-column
        label="下架/上架">
      <template slot-scope="scope">
        <el-switch
          :value="scope.row.isShelf === 1"
          @change="handleIsShelf(scope.row.id, scope.row.isShelf)"
        ></el-switch>
      </template>
    </el-table-column>
    <el-table-column
        label="创建时间">
      <template slot-scope="scope">
          <span v-if="scope.row.createdTime">
            <span v-bind:class="{unabletime: scope.row.createdTime > (new Date()).getTime()}">{{scope.row.createdTime | moment}}</span>
          </span>
      </template>
    </el-table-column>
    <el-table-column
        label="更新时间">
      <template slot-scope="scope">
          <span v-if="scope.row.updateTime">
            <span v-bind:class="{unabletime: scope.row.updateTime > (new Date()).getTime()}">{{scope.row.updateTime | moment}}</span>
          </span>
      </template>
    </el-table-column>
    <el-table-column
      label="操作">
      <template slot-scope="scope">
        <el-button
          type="primary"
          icon="el-icon-edit"
          circle
          size="small"
          @click="handleEdit(scope.row)"
        ></el-button>
        <el-button
          type="danger"
          icon="el-icon-delete"
          circle
          size="small"
          @click="handleRemove(scope.row.id)"
        ></el-button>
      </template>
    </el-table-column>
  </el-table>
  <pagination
    :size="pagination.size"
    :page="pagination.page"
    :total="totalCount"
    @pageChanged="handlePageChanged"
    >
  </pagination>
  <notice-detail @refresh="refreshList" :id="noticeId"></notice-detail>
</div>
</template>

<script>
import {mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import Pagination from 'components/pagination';
import NoticeDetail from '../detail/noticeIndex.vue';

export default {
  name: 'NoticeList',
  data() {
    return {
      noticeId: null
    };
  },
  components: {
    Pagination,
    NoticeDetail
  },
  computed: {
    ...mapState('BannerNewSetting', [
      'noticeList',
      'pagination',
      'totalCount'])
  },
  methods: {
    ...mapMutations('BannerNewSetting', ['toggleNoticeDetailDialogVisible']),
    ...mapActions('BannerNewSetting', ['removeNotice', 'noticeIsShelf']),
    handlePageChanged({ page, size }) {
      // 改用 mutation 修改分页参数
      this.$store.commit('BannerNewSetting/SET_PAGINATION', { page, size })
      this.$emit('refresh', {
        page: this.pagination.page,
        size: this.pagination.size
      })
    },
    handleEdit(notice) {
      this.noticeId = notice.id;
      this.toggleNoticeDetailDialogVisible(true);
    },
    handleRemove(id) {
      this.$confirm('确认要删除该公告吗？', '提示', { type: 'warning' }).then(
        () => {
          this.removeNotice(id).then(() => {
            this.$message.success('删除成功！');
            this.$emit('refresh');
          });
        }
      );
    },
    handleIsShelf(id, isShelf) {
      this.$confirm('确认要修改上/下架状态吗？', '提示', { type: 'warning' }).then(
        () => {
          // 修改调用方式，参数改为对象形式传递
          this.noticeIsShelf({id, isShelf}).then(() => {
            this.$message.success('状态修改成功！'); // 修正提示文案
            this.$emit("refresh");
          });
        }
      );
    },
    refreshList() {
      this.$emit('refresh');
    }
  }
}
</script>

<style lang="less" scoped>

</style>
